module.exports = __webpack_public_path__ + "img/9.f362bf79.png";